import cn from 'classnames';
import type { PropsWithChildren } from 'react';

import Typography from '~/components/Typography';

type Props = PropsWithChildren<{
  isSelected: boolean;
}>;

const OptionLabel = ({ children, isSelected }: Props) => {
  return (
    <Typography
      as="p"
      size="sm"
      weight={isSelected ? 'medium' : 'regular'}
      className={cn(isSelected ? 'text-[#111827]' : 'text-[#374151]')}
    >
      {children}
    </Typography>
  );
};

export default OptionLabel;
